
  import { defineComponent, PropType } from 'vue';

  export default defineComponent({
    name: 'MapLegend',
    props: {
      title: {
        type: String,
        default: '',
      },
      background: {
        type: String,
        default: '',
      },
      marks: {
        type: Array as PropType<string[]>,
        default: () => [],
      },
    },
  });
